export default "__VITE_ASSET__d521ebdf__"